import { VISIBILITY_META, VIS_FIREMNI } from "../../lib/taskVisibility";

const sel = "text-xs border border-slate-300 bg-white px-2 py-1.5 rounded-sm focus:outline-none focus:border-orange-600 min-w-0";

export function TaskFilters({ filters, setFilters, team, jobs, tech, tab }) {
    const set = (k, v) => setFilters({ ...filters, [k]: v });
    const showType = tab !== "tymove" && tab !== "firemni";
    const active = Object.values(filters).some(Boolean);
    return (
        <div className="flex flex-wrap items-center gap-2 mb-3" data-testid="task-filters">
            {showType && (
                <select value={filters.visibility} onChange={(e) => set("visibility", e.target.value)} className={sel} data-testid="filter-visibility">
                    <option value="">Všechny typy</option>
                    {Object.entries(VISIBILITY_META).filter(([k]) => !(tech && k === VIS_FIREMNI)).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
                </select>
            )}
            <select value={filters.job_id} onChange={(e) => set("job_id", e.target.value)} className={sel} data-testid="filter-job">
                <option value="">Všechny zakázky</option>
                {jobs.map((j) => <option key={j.id} value={j.id}>{j.title}</option>)}
            </select>
            <select value={filters.assignee_id} onChange={(e) => set("assignee_id", e.target.value)} className={sel} data-testid="filter-assignee">
                <option value="">Kdokoliv</option>
                {team.map((m) => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
            </select>
            <select value={filters.due} onChange={(e) => set("due", e.target.value)} className={sel} data-testid="filter-due">
                <option value="">Jakýkoliv termín</option>
                <option value="po_terminu">Po termínu</option>
                <option value="dnes">Dnes</option>
                <option value="tyden">Do týdne</option>
                <option value="bez_terminu">Bez termínu</option>
            </select>
            {active && (
                <button onClick={() => setFilters({ visibility: "", job_id: "", assignee_id: "", due: "" })} data-testid="filter-reset"
                        className="text-xs text-slate-500 hover:text-orange-600 underline underline-offset-2">Zrušit filtry</button>
            )}
        </div>
    );
}
